import { render, staticRenderFns } from "./UpdateForm.vue?vue&type=template&id=875ab54a&"
import script from "./UpdateForm.vue?vue&type=script&lang=js&"
export * from "./UpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateForm.vue?vue&type=style&index=0&id=875ab54a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('875ab54a')) {
      api.createRecord('875ab54a', component.options)
    } else {
      api.reload('875ab54a', component.options)
    }
    module.hot.accept("./UpdateForm.vue?vue&type=template&id=875ab54a&", function () {
      api.rerender('875ab54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accomodation/UpdateForm.vue"
export default component.exports